<script lang="ts">
	import Pin from 'components/search/Pin.svelte'
	import Input from '@isoftdata/svelte-input'
	import type { i18n } from 'types/common'
	import { getContext } from 'svelte'
	const { t: translate } = getContext<i18n>('i18next')

	interface Props {
		label?: string
		to?: number | null
		disabled?: boolean
		isPinned?: boolean
		from?: number | null
		id?: string
		change?: (value: { from: number | null; to: number | null }) => void
	}

	let {
		label = '',
		to = $bindable(null),
		disabled = false,
		isPinned = false,
		from = $bindable(null),
		id = '',
		change,
	}: Props = $props()
</script>

<label
	for={id}
	class="col-form-label pb-0"
	>{label} <Pin {isPinned} />
</label>
<div class="form-row">
	<div class="col-12 col-md-6">
		<Input
			{id}
			label={translate('common:from', 'From')}
			bind:value={from}
			type="number"
			inputmode="decimal"
			onchange={() => {
				if (from && !to) {
					to = from
				}
				change?.({ from, to })
			}}
			{disabled}
		/>
	</div>

	<div class="col-12 col-md-6">
		<Input
			bind:value={to}
			label={translate('common:to', 'To')}
			type="number"
			inputmode="decimal"
			onchange={() => change?.({ from, to })}
			{disabled}
		/>
	</div>
</div>
